import { render, staticRenderFns } from "./NotificationAlert.vue?vue&type=template&id=58d5025b&scoped=true&"
import script from "./NotificationAlert.vue?vue&type=script&lang=ts&"
export * from "./NotificationAlert.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationAlert.vue?vue&type=style&index=0&id=58d5025b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d5025b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VContainer})
